module.exports = __webpack_public_path__ + "img/bg.ee0978c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/online_env/bg.png
// module id = wB9j
// module chunks = 16